import { render, staticRenderFns } from "./sidebarBlock.vue?vue&type=template&id=9fdbae60&scoped=true"
import script from "./sidebarBlock.vue?vue&type=script&lang=js"
export * from "./sidebarBlock.vue?vue&type=script&lang=js"
import style0 from "./sidebarBlock.vue?vue&type=style&index=0&id=9fdbae60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdbae60",
  null
  
)

export default component.exports